// extracted by mini-css-extract-plugin
export default {"container":"ProductCard_container__-5UjE","image":"ProductCard_image__ZPsr1","imageFallback":"ProductCard_imageFallback__TX5Rv"};